// export const base_api = 'https://localhost:44302/api';
// export const base_api = 'http://localhost:5004/api';
// export const base_api = 'https://api-lead.key4.events/api';
export const base_api = 'https://api-lead.key4.events/api';



// WEBPACK FOOTER //
// ./src/services/base.js